import React, { useEffect, useState, useRef, useCallback } from "react";
import "./styles/brand-theme.css";
import "./pages/DashBaord/main_dashboard.css";
import "./App.css";
import LoginPage from "./components/LoginPage/LoginPage.js";
import ResetPassword from "./components/LoginPage/ResetPassword.js";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import NotFound from "./pages/NotFound.jsx";
import UnderMaintenance from "./components/underMaintenance.js";
import Sidebar from "./components/SideBar/Sidebar.jsx";
import Dashboard from "./pages/DashBaord/Dashboard.jsx";
import SubAdminList from "./pages/Accounts/SubAdmin/List.js";
import SubAdminAddEditData from "./pages/Accounts/SubAdmin/AddEditData.js";
import { fetchIpAddress } from "./controllers/API";
import { decryptData } from "./controllers/Encryption.js";

import { PermissionProvider } from "./controllers/PermissionContext.js";

////////////////////////////////////////////////////////////////////////////////////////

import UsersList from "./pages/v1/users/List.js";
import B2BUserList from "./pages/v1/users/B2BUserList.js";
import B2CUserList from "./pages/v1/users/B2CUserList.js";
import PromocodeList from "./pages/v1/promocodes/List.js";
import UsersAddEdit from "./pages/v1/users/AddEditData.js";
import PromocodeOrder from "./pages/v1/promocodes/Order.js";
import BPointList from "./pages/v1/recharge/points/List.js";
import PromocodeEditPage from "./pages/v1/promocodes/AddEditData.js";

import PromoCodeVoucher from "./pages/v1/promocodes/vouchers/List.js";

import ProductList from "./pages/v1/products/list.js";
import ProductVariant from "./pages/v1/products/variants/variants.js";
import ProductAddEditPage from "./pages/v1/products/AddEditData.js";
import OrdersDetails from "./pages/v1/promocodes/orderdetails.js";
import ProductDetails from "./pages/v1/products/productDetails.js";
import AddEditVariantData from "./pages/v1/products/variants/AddEditVariantsData.js";
import VariantLogs from "./pages/v1/products/Variant_log/list.js";

// import InventoryList from './pages/v1/products/inventoryList.js';
// import AddEditInventoryData from "./pages/v1/products/AddEditInventoryData.js";

import InventoryList from "./pages/v1/products/Inventory/list.js";
import InventoryLogs from "./pages/v1/products/Inventory_logs/list.js";
import AddEditInventoryData from "./pages/v1/products/Inventory/AddEditData.js";

import OrderList from "./pages/v1/products/OrderList.js";
import OrderDetails from "./pages/v1/products/OrderDetails.js";
import CampaignList from "./pages/v1/campaign/campaignList.js";
import GeneralAddEditData from "./pages/v1/Cms/generalAddEdit.js";
import RaffleCouponContentAddEdit from "./pages/v1/raffleCoupon/RaffleCouponContentAddEdit.js";
import CampaignAddEdit from "./pages/v1/campaign/campaignAddEdit.js";
// import DrawDateTime from "./pages/v1/Cms/campaign/drawDateTime.js"
import PrizeAddEdit from "./pages/v1/campaign/prizeAddEdit.js";
import PrizeList from "./pages/v1/campaign/prizeList.js";
import SettingAddEdit from "./pages/v1/campaign/settingAddEdit.js";
import CampaignOrderList from "./pages/v1/campaign/orderList.js";

import RaffleWinners from "./pages/v1/raffleWinners/List.js";
import RaffleWinnersAddEdit from "./pages/v1/raffleWinners/AddEditData.js";

import BannerList from "./pages/v1/Cms/Banner/list.js";
import CampaignOrderDetails from "./pages/v1/campaign/campaignOrderDetails.js";
import BannerAddEditData from "./pages/v1/Cms/Banner/addEdit.js";
import Freezes from "./pages/v1/campaign/freezes.js";

// import { useUserStore } from "./lib/userStore.js";
import LottoWinnerList from "./pages/v1/lottoWinners/List.js";
import LottoWinnerDetailedList from "./pages/v1/lottoWinners/DetailedList.js";
import LottoWinnerRedeemedList from "./pages/v1/lottoWinners/redeemed/List.js";
import WinnerAnalyser from "./pages/v1/lottoWinners/analyser/list.js"


import RaffleDrawList from "./pages/v1/raffleDraw/list.js";
import RaffleDrawAddEdit from "./pages/v1/raffleDraw/addEditDataRaffleDraw.js";

import WalletStatementList from "./pages/v1/walletstatement/List.js";
import TransactionList from "./pages/v1/transactions/List.js";
import ActiveLogs from "./pages/v1/activelogs/List.js";

//Invice
import InvoiceList from "./pages/v1/invoice/individual/List.js";
import InvoiceAddEdit from "./pages/v1/invoice/individual/AddEditData.js";
import PreviewInvoice from "./pages/v1/invoice/preview.js";

import BulkInvoiceList from "./pages/v1/invoice/bulk/List.js";
import BulkCreateRequest from "./pages/v1/invoice/bulk/CreateRequest.js";
import BulkRequestList from "./pages/v1/invoice/bulk/RetailersList.js";
import BulkPreview from "./pages/v1/invoice/bulk/BulkPreview.js";
import BulkDownload from "./pages/v1/invoice/bulk/DownloadInvoice.jsx"
//End

import StatisticsReports from "./pages/v1/statisticsReports/List.js";
import SmartRtpDashboard from "./pages/v1/smartRtp/Dashboard.jsx";
import SmartRtpGamesPage from "./pages/v1/smartRtp/Games.jsx";
import SmartRtpReportsPage from "./pages/v1/smartRtp/Reports.jsx";
import SmartRtpReportDetailsPage from "./pages/v1/smartRtp/ReportDetails.jsx";
import SmartRtpAnalyticsPage from "./pages/v1/smartRtp/Analytics.jsx";
import SmartRtpAuditLogsPage from "./pages/v1/smartRtp/AuditLogs.jsx";
import SmartRtpRuntimePage from "./pages/v1/smartRtp/Runtime.jsx";
import SmartRtpGameFormPage from "./pages/v1/smartRtp/GameForm.jsx";
import SmartRtpPoolFormPage from "./pages/v1/smartRtp/PoolForm.jsx";
import SmartRtpSlabFormPage from "./pages/v1/smartRtp/SlabForm.jsx";
import SmartRtpBuyerRewardFormPage from "./pages/v1/smartRtp/BuyerRewardForm.jsx";
import SmartRtpSettingsFormPage from "./pages/v1/smartRtp/SettingsForm.jsx";
import SmartRtpOrdersPage from "./pages/v1/smartRtp/Orders.jsx";
import SmartRtpOrderDetailsPage from "./pages/v1/smartRtp/OrderDetails.jsx";
import SmartRtpWinnersPage from "./pages/v1/smartRtp/Winners.jsx";
import SmartRtpWinnersDetailsPage from "./pages/v1/smartRtp/WinnersDetails.jsx";
import SmartRtpBigPrizeMonitorPage from "./pages/v1/smartRtp/BigPrizeMonitor.jsx";
import SmartRtpBigPrizeBulkHistoryPage from "./pages/v1/smartRtp/BigPrizeBulkHistory.jsx";
import SmartRtpBigPrizeFormPage from "./pages/v1/smartRtp/BigPrizeForm.jsx";
import SmartRtpPredictDistributionPage from "./pages/v1/smartRtp/PredictDistribution.jsx";
import UserRequestList from "./pages/v1/userRequest/List.js";
import UserRequestView from "./pages/v1/userRequest/View.js";
import PullOutRequestList from "./pages/v1/pullOutRequest/List.js";
import PullOutRequestView from "./pages/v1/pullOutRequest/View.js";

import PickPointsList from "./pages/v1/Cms/pickuppoints/list.js"
import PickupPointAddEdit from  "./pages/v1/Cms/pickuppoints/addEdit.js";

import WinningResultsList from "./pages/v1/Cms/winning_results/list.js";
import WinningResultsDetails from "./pages/v1/Cms/winning_results/detailsList.js";
import WinningResultsAddEdit from "./pages/v1/Cms/winning_results/addEdit.js";

// Winning vouchers
import WinnerVoucherPreview from "./pages/v1/winning_vouchers/Preview.js";
import WinnerVoucherPreviewPDF from "./pages/v1/winning_vouchers/PreviewPDF.js";
import WinningVouchersList from "./pages/v1/winning_vouchers/List.js";
import GenerateVoucher from "./pages/v1/winning_vouchers/AddData.js";

import DownloadOrder from "./pages/v1/promocodes/DownloadOrder.js";
import PublicVoucherPreview from "./pages/v1/winning_vouchers/PublicPreview.js";
import BuyWinCoupon from "./pages/v1/raffleCoupon/BuyWinCoupon.js";

import AgentLogin from "./pages/Agents/Login/AgentLogin.js";
import AssignedWinningVoucherList from "./pages/Agents/winning_vouchers/AssignedList.js";
import AgentVoucherPreviewPDF from "./pages/Agents/winning_vouchers/PreviewPDF.js";

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const { fetchUserInfo } = useUserStore();
  const user = JSON.parse(localStorage.getItem("ADMIN-INFO")) || JSON.parse(sessionStorage.getItem("AGENT-ADMIN-INFO"));
  const INACTIVITY_TIMEOUT = 60 * 60 * 1000; // 30 minutes in milliseconds
  const inactivityTimerRef = useRef(null);
  const lastActivityRef = useRef(Date.now());

  const getIp = async () => {
    await fetchIpAddress();
  };

  // Logout function to clear session
  const handleAutoLogout = useCallback(() => {
    localStorage.removeItem("TOKEN");
    localStorage.removeItem("ADMIN-INFO");
    localStorage.removeItem("ADMIN-PERMISSION");
    sessionStorage.removeItem("AGENT-TOKEN");
    sessionStorage.removeItem("AGENT-ADMIN-INFO");
    navigate("/site-admin-login-2302");
  }, [navigate]);

  // Reset inactivity timer (optimized with throttling)
  const resetInactivityTimer = useCallback(() => {
    // Throttle: Only reset if at least 1 second has passed since last activity
    const now = Date.now();
    if (now - lastActivityRef.current < 5000) {
      return; // Skip if called within 1 second
    }
    lastActivityRef.current = now;

    // Clear existing timer
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
    }

    // Only set timer if user is authenticated and not on public pages
    const token = localStorage.getItem("TOKEN") || sessionStorage.getItem("AGENT-TOKEN");
    const publicPaths = ["/site-admin-login-2302", "/login", "/reset-password", "/invoice/preview", "/promocodes/download-order", "/voucher", "/buy-win-coupon"];
    const isPublicPath = publicPaths.some(
      path => location?.pathname === path || location?.pathname.startsWith(path + "/")
    );

    if (token && !isPublicPath) {
      // Set new timer
      inactivityTimerRef.current = setTimeout(() => {
        handleAutoLogout();
      }, INACTIVITY_TIMEOUT);
    }
  }, [location, handleAutoLogout, INACTIVITY_TIMEOUT]);

  // Setup activity listeners
  useEffect(() => {
    const token = localStorage.getItem("TOKEN") || sessionStorage.getItem("AGENT-TOKEN");
    if (!token) return;

    const publicPaths = ["/site-admin-login-2302", "/login", "/reset-password", "/invoice/preview", "/promocodes/download-order", "/voucher", "/buy-win-coupon"];
    const isPublicPath = publicPaths.some(
      path => location?.pathname === path || location?.pathname.startsWith(path + "/")
    );

    if (isPublicPath) return;

    // Events that indicate user activity (removed 'mousemove' for better performance)
    const events = ['mousedown', 'keypress', 'scroll', 'touchstart', 'click'];

    // Reset timer on any activity
    events.forEach(event => {
      document.addEventListener(event, resetInactivityTimer, { passive: true });
    });

    // Initialize timer
    resetInactivityTimer();

    // Cleanup
    return () => {
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
      events.forEach(event => {
        document.removeEventListener(event, resetInactivityTimer);
      });
    };
  }, [location, resetInactivityTimer]);

  useEffect(() => {
    const checkAuthentication = async () => {
      await getIp();
      const token = localStorage.getItem("TOKEN") || sessionStorage.getItem("AGENT-TOKEN");
      const publicPaths = [ "/site-admin-login-2302", "/login", "/reset-password", "/invoice/preview", "/promocodes/download-order", "/voucher", "/agent-login", "/buy-win-coupon"];
      const isPublicPath = publicPaths.some(
        path => location?.pathname === path || location?.pathname.startsWith(path + "/")
      );
      if (!isPublicPath && (!token || token === null)) {
        navigate("/");
      }
    };

    checkAuthentication();
  }, [location, navigate]);

  // const [PERMISSIONDATA, setPermissionData] = useState("");
  const handlePermission = async () => {
    const encrypted = JSON.parse(localStorage.getItem("ADMIN-PERMISSION"));
    // const decrypted = await decryptData(encrypted);
    // const permission = JSON.parse(decrypted);
    // setPermissionData(permission);
  };
 
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("ADMIN-INFO"));
    if (
      userData &&
      localStorage.getItem("ADMIN-PERMISSION") !== "undefined" &&
      userData?.admin_type !== "Super Admin"
    ) {
      handlePermission();
    }
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<UnderMaintenance />} />
        <Route path="/site-admin-login-2302" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/dashboard"
          element={
            <Sidebar>
              <PermissionProvider>
                <Dashboard />
              </PermissionProvider>
            </Sidebar>
          }
        />

        <Route key="agent-login" path="/agent-login" element={<AgentLogin />} />
        <Route
          key="voucher-list"
          path="/voucher-list"
          element={<AssignedWinningVoucherList />}
        />
        <Route
          key="voucher-pdf"
          path="/voucher-pdf"
          element={<AgentVoucherPreviewPDF />}
        />
        {user?.admin_type === "Super Admin" && (
          <>
            <Route
              path="/sub-admin/list"
              element={
                <Sidebar>
                  <PermissionProvider>
                    <SubAdminList />
                  </PermissionProvider>
                </Sidebar>
              }
            />
          </>
        )}

        <Route
          path="/sub-admin/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <SubAdminAddEditData />
              </PermissionProvider>
            </Sidebar>
          }
        />

        {/* product */}
        <Route
          path="/product/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <ProductList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <ProductAddEditPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product_details"
          element={
            <Sidebar>
              <PermissionProvider>
                <ProductDetails />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/variants/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <ProductVariant />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/variants/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <AddEditVariantData />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/inventory/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <InventoryList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/inventory/logs"
          element={
            <Sidebar>
              <PermissionProvider>
                <InventoryLogs />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/variants/logs"
          element={
            <Sidebar>
              <PermissionProvider>
                <VariantLogs />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/inventory/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <AddEditInventoryData />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/order/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <OrderList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/order/details"
          element={
            <Sidebar>
              <PermissionProvider>
                <OrderDetails />
              </PermissionProvider>
            </Sidebar>
          }
        />

        {/* promocodes */}
        <Route
          path="/promocodes/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <PromocodeList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/promocodes/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <PromocodeEditPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/promocodes/order"
          element={
            <Sidebar>
              <PermissionProvider>
                <PromocodeOrder />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/promocodes/orderDetails"
          element={
            <Sidebar>
              <PermissionProvider>
                <OrdersDetails />
              </PermissionProvider>
            </Sidebar>
          }
        />

        <Route
          path="/promocodes/download-order/:order_id"
          element={
            <DownloadOrder />
          }
        />

        <Route
          path="/voucher/:order_id"
          element={
            <PublicVoucherPreview />
          }
        />

        <Route path="/buy-win-coupon" element={<BuyWinCoupon />} />

        <Route
          path="/promocodes/vouchers/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <PromoCodeVoucher />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* end procodes */}
        <Route
          path="/users/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <UsersList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/users/B2B-user-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <B2BUserList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/users/B2C-user-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <B2CUserList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/users/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <UsersAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/recharge/b-point-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <BPointList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        {/* cms */}
        <Route
          path="/cms/general_data/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <GeneralAddEditData />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/cms/raffle-coupon-content/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <RaffleCouponContentAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/cms/pickup-point/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <PickPointsList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/cms/pickup-point/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <PickupPointAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/cms/winning-results/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <WinningResultsList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/cms/winning-results/details/:draw_date"
          element={
            <Sidebar>
              <PermissionProvider>
                <WinningResultsDetails />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/cms/winning-results/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <WinningResultsAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/prize/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <PrizeAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/prize/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <PrizeList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/setting/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <SettingAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/order/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <CampaignOrderList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/order/details"
          element={
            <Sidebar>
              <PermissionProvider>
                <CampaignOrderDetails />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/freezes"
          element={
            <Sidebar>
              <PermissionProvider>
                <Freezes />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        <Route
          path="/campaign/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <CampaignList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <CampaignAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* cms */}

        <Route
          path="/cms/general_data/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <GeneralAddEditData />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/cms/raffle-coupon-content/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <RaffleCouponContentAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/cms/banner/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <BannerList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/cms/banner/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <BannerAddEditData />
              </PermissionProvider>
            </Sidebar>
          }
        />

        {/* End */}
        {/* Raffle Winners */}
        <Route
          path="/raffle-winners/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <RaffleWinners />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/raffle-winners/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <RaffleWinnersAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        {/* raffle draw  */}
        <Route
          path="/raffle-draw/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <RaffleDrawList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/raffle-draw/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <RaffleDrawAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        {/* Lotto Winners */}
        <Route
          path="/lotto-winners/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <LottoWinnerList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/lotto-winners/detailed-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <LottoWinnerDetailedList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/lotto-winners/redeem-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <LottoWinnerRedeemedList />
              </PermissionProvider>
            </Sidebar>
          }
        />

        <Route
          path="/lotto-winners/analyser"
          element={
            <Sidebar>
              <PermissionProvider>
                <WinnerAnalyser />
              </PermissionProvider>
            </Sidebar>
          }
        />

        {/* End */}

        {/* Lotto Winners */}
        <Route
          path="/wallets-statement/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <WalletStatementList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        {/* Transactions */}
        <Route
          path="/transactions/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <TransactionList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        {/* Active Logs */}
        <Route
          path="/active-logs"
          element={
            <Sidebar>
              <PermissionProvider>
                <ActiveLogs />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        {/* Invoice*/}
        <Route
          path="/invoice/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <InvoiceList />
              </PermissionProvider>
            </Sidebar>
          }
        />

        <Route
          path="/invoice/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <InvoiceAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />

        <Route
          path="/invoice/preview"
          element={
            <PermissionProvider>
              <PreviewInvoice />
            </PermissionProvider>
          }
        />
        
        <Route
          path="/invoice/bulk-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <BulkInvoiceList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/invoice/create-request"
          element={
            <Sidebar>
              <PermissionProvider>
                <BulkCreateRequest />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/invoice/retailers-list/:batch_id"
          element={
            <Sidebar>
              <PermissionProvider>
                <BulkRequestList />
              </PermissionProvider>
            </Sidebar>
          }
        />

        <Route
          path="/invoice/bulk-preview/:batch_id"
          element={
            <Sidebar>
              {/* <PermissionProvider> */}
                <BulkPreview />
              {/* </PermissionProvider> */}
            </Sidebar>
          }
        />

        <Route
          path="/invoice/bulk/download-all"
          element={
            <Sidebar>
              <PermissionProvider>
                <BulkDownload />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}
        {/* Statistics Reports */}
        <Route
          path="/statistics-reports"
          element={
            <Sidebar>
              <PermissionProvider>
                <StatisticsReports />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* END */}
        {/* Smart RTP */}
        <Route
          path="/smart-rtp/dashboard"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpDashboard />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/games"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpGamesPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/games/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpGameFormPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/orders"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpOrdersPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/orders/details"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpOrderDetailsPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/winners"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpWinnersPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/winners/details"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpWinnersDetailsPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/big-prize-monitor"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpBigPrizeMonitorPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/big-prize/history"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpBigPrizeBulkHistoryPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/big-prize/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpBigPrizeFormPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/pools"
          element={<Navigate to="/smart-rtp/games" replace />}
        />
        <Route
          path="/smart-rtp/pools/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpPoolFormPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/slabs"
          element={<Navigate to="/smart-rtp/games" replace />}
        />
        <Route
          path="/smart-rtp/slabs/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpSlabFormPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/buyer-reward"
          element={<Navigate to="/smart-rtp/games" replace />}
        />
        <Route
          path="/smart-rtp/buyer-reward/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpBuyerRewardFormPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/predict-distribution"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpPredictDistributionPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/reports"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpReportsPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/reports/details"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpReportDetailsPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/analytics"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpAnalyticsPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/audit-logs"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpAuditLogsPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/runtime"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpRuntimePage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/smart-rtp/settings"
          element={<Navigate to="/smart-rtp/games" replace />}
        />
        <Route
          path="/smart-rtp/settings/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <SmartRtpSettingsFormPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End Smart RTP */}
        {/* Winning Vouchers */}
        <Route
          path="/winning-vouchers/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <WinningVouchersList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/winners/generate-voucher"
          element={
            <Sidebar>
              <PermissionProvider>
                <GenerateVoucher />
              </PermissionProvider>
            </Sidebar>
          }
        />
        
        <Route
          path="/winners/voucher"
          element={
            <Sidebar>
              <PermissionProvider>
                <WinnerVoucherPreview />
              </PermissionProvider>
            </Sidebar>
          }
        />

        <Route
          path="/winners/voucher-pdf"
          element={
            <Sidebar>
              <PermissionProvider>
                <WinnerVoucherPreviewPDF />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        {/* User Request */}
        <Route
          path="/users/request-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <UserRequestList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/users/request-view"
          element={
            <Sidebar>
              <PermissionProvider>
                <UserRequestView />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        {/* Pull-Out Request */}
        <Route
          path="/request/pull-out-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <PullOutRequestList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/request/pull-out-view"
          element={
            <Sidebar>
              <PermissionProvider>
                <PullOutRequestView />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        <Route
          path="*"
          element={
                <NotFound />
          }
        />
      </Routes>
    </div>
  );
};

export default App;
